import { render, staticRenderFns } from "./reseller_update.vue?vue&type=template&id=713a2664"
import script from "./reseller_update.vue?vue&type=script&lang=js"
export * from "./reseller_update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports